import {Request}                from "../../../request.abstract";
import {Observable}             from "rxjs";
import {Schemas}                from "./schemas.interface";
import {Schema}                 from "./schema.interface";
import {ContactMomentsEndpoint} from "./contactMoments/api.service";
import {Http}                   from '@angular/http';
import {Settings}               from '../../../settings.model';

export class SchemasEndpoint extends Request {
    protected contactMomentEndpoint: any = {};
    protected baseId: number;

    constructor(http: Http, settings: Settings, baseId: number) {
        super(http, settings);
        this.baseId = baseId;
    }

    collection(page: number, perPage: number, name?: string): Observable<Schemas> {
        return this.get('/v1/bases/' + this.baseId + '/proxy/v1/schemas', this.createSearch({page : page, perPage : perPage, name: name}));
    }

    resource(id: number): Observable<Schema> {
        return this.get('/v1/bases/' + this.baseId + '/proxy/v1/schemas/' + id);
    }

    add(schema: any): Observable<Schema> {
        return this.post('/v1/bases/' + this.baseId + '/proxy/v1/schemas', schema);
    }

    update(id: number, schema: Schema): Observable<Schema> {
        return this.patch('/v1/bases/' + this.baseId + '/proxy/v1/schemas/' + id, schema);
    }

    remove(id: number): Observable<any> {
        return this.delete('/v1/bases/' + this.baseId + '/proxy/v1/schemas/' + id);
    }

    contactMoments(id: number): ContactMomentsEndpoint {
        if (this.contactMomentEndpoint[id] === undefined) {
            this.contactMomentEndpoint[id] = new ContactMomentsEndpoint(this.http, this.settings, this.baseId, id);
        }

        return this.contactMomentEndpoint[id];
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/shared/api/bases/proxy/schemas/api.service.ts